import userFiltersSignal, {
	setUserFilters,
} from '@UI/Pages/Administration/Users/Filters/Signals/userFiltersSignal';
import type { UserStatusFilter } from '@UI/Pages/Administration/Users/Filters/UserFilterView';
import * as React from 'react';
import { useSignalValue } from '@verclam/pulsar';
import { Dropdown } from '@verclam/ui-kit';

type StatusOption = { readonly value: string; readonly label: string };

type Props = {
	readonly statuses: readonly StatusOption[];
	readonly disabled: boolean;
	readonly withLabel?: boolean;
};

const StatusFilter: React.FC<Props> = ({ statuses, disabled, withLabel = false }) => {
	const currentFilters = useSignalValue(userFiltersSignal);

	const handleStatusChange = React.useCallback((status: UserStatusFilter | null) => {
		setUserFilters(userFiltersSignal.peek().setStatus(status));
	}, []);

	return (
		<Dropdown<UserStatusFilter>
			name="userStatus"
			label="Statut"
			isLabelHidden={!withLabel}
			placeholder="Tous les statuts"
			options={statuses}
			optionLabel="label"
			optionValue="value"
			disabled={disabled}
			showClear
			value={currentFilters.status}
			onChange={handleStatusChange}
		/>
	);
};

export default StatusFilter;
